import { ColumnSetting } from '../../../../../_foundation/models/grid.models';

export const frequencyColumns: ColumnSetting[] = [
  {
    field: 'effectiveFromDate',
    title: 'Effective From',
    filter: 'text',
    filterable: false,
    width: 100
  },
  {
    field: 'frequencyShow',
    title: 'Recording Frequency',
    filter: 'text',
    width: 150
  },
  {
    field: 'observationStartTime',
    title: 'Observation Start',
    filter: 'text',
    filterable: false,
    width: 100
  },
  {
    field: 'observationEndTime',
    title: 'Observation End',
    filter: 'text',
    filterable: false,
    width: 100
  },
  {
    field: 'actions',
    title: 'Actions',
    width: 80
  }
];



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/components/daily-leg-load-frequency-change-grid/daily-leg-loads-frequency.config.ts